import React from 'react'
import { Button, Tooltip, CircularProgress } from '@mui/material'
import { useTranslation } from 'react-i18next'

interface ResumeButtonProps {
    mostRecentStory: { storyId: string; storyTitle: string } | null
    progressLoading: boolean
    isLessonPage: boolean
    onClick: () => void
    llmLocked?: boolean
}

export const ResumeButton: React.FC<ResumeButtonProps> = ({
    mostRecentStory,
    progressLoading,
    isLessonPage,
    onClick,
    llmLocked = false,
}) => {
    const { t } = useTranslation()

    const isResumeEnabled = !!mostRecentStory && !llmLocked
    const resumeAriaLabel = mostRecentStory
        ? t('navigation:resume.aria', { title: mostRecentStory.storyTitle })
        : t('navigation:resume.loading')

    const tooltipTitle = llmLocked
        ? t('errors:llmQuota.lockTooltip')
        : !mostRecentStory
          ? t('navigation:resume.tooltip.empty')
          : ''

    return (
        <Tooltip title={tooltipTitle} disableHoverListener={!tooltipTitle}>
            <span>
                <Button
                    color="inherit"
                    onClick={onClick}
                    disabled={!isResumeEnabled}
                    aria-disabled={!isResumeEnabled}
                    aria-label={resumeAriaLabel}
                    sx={{
                        fontWeight: 400,
                        backgroundColor:
                            isResumeEnabled && isLessonPage ? 'action.selected' : 'transparent',
                        minWidth: (theme) => theme.spacing(10), // Prevent layout shift
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        color: isResumeEnabled ? 'text.primary' : 'text.disabled',
                        '&:hover': {
                            backgroundColor: isResumeEnabled ? 'action.hover' : 'transparent',
                        },
                    }}
                >
                    {progressLoading ? (
                        <CircularProgress size={16} color="inherit" />
                    ) : (
                        t('navigation:resume')
                    )}
                </Button>
            </span>
        </Tooltip>
    )
}
